import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const CGVPage = () => {
  const navigate = useNavigate();

  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.5 }
  };

  const articles = [
    {
      title: 'Article 1 – Objet',
      content: `Les présentes Conditions Générales de Vente (ci-après « CGV ») régissent les modalités d'accès, d'inscription, de souscription et d'utilisation de la plateforme Coach DIA, plateforme de formation professionnelle en ligne dédiée au développement des compétences managériales, accessible via le site internet Coach DIA.

Toute souscription à un service proposé par Coach DIA implique l'acceptation sans réserve des présentes CGV.`
    },
    {
      title: 'Article 2 – Identification de l\'éditeur',
      content: `Coach DIA
Plateforme de formation professionnelle en ligne
Éditeur : AMSY ECOM
Statut juridique : SAS
Adresse du siège social : Impasse camomilles, Draveil
Email de contact : contact@coachdia.com
Numéro SIREN / SIRET : 93529817400019`
    },
    {
      title: 'Article 3 – Description des services',
      content: `Coach DIA propose :
• des parcours de formation professionnelle à distance,
• composés de modules pédagogiques,
• intégrant des cours théoriques (lecture et audio),
• des entraînements pratiques (écrit et vocal),
• un accompagnement par un coach IA pédagogique.

Les services sont accessibles via un abonnement payant ou toute autre formule précisée lors de la souscription.`
    },
    {
      title: 'Article 4 – Public concerné',
      content: `Les services Coach DIA s'adressent principalement à :
• managers,
• responsables d'équipe,
• chefs de projet,
• professionnels souhaitant développer leurs compétences managériales.

Aucun prérequis technique n'est exigé, hormis :
• un accès à Internet,
• un équipement compatible,
• une compréhension suffisante de la langue française.`
    },
    {
      title: 'Article 5 – Modalités d\'inscription et d\'accès',
      content: `L'accès à la plateforme nécessite :
• la création d'un compte personnel,
• la fourniture d'informations exactes et à jour,
• la souscription à une offre active.

L'utilisateur est seul responsable de la confidentialité de ses identifiants.`
    },
    {
      title: 'Article 6 – Prix et modalités de paiement',
      content: `Les prix des services sont indiqués en euros, toutes taxes comprises, sauf mention contraire.

Le paiement s'effectue :
• par carte bancaire,
• via un prestataire de paiement sécurisé.

Les abonnements sont facturés selon la périodicité indiquée lors de la souscription.`
    },
    {
      title: 'Article 7 – Droit de rétractation',
      content: `Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux contenus numériques et services de formation accessibles immédiatement après paiement, lorsque l'utilisateur a expressément renoncé à son droit de rétractation.

Cette renonciation est validée lors de la souscription.`
    },
    {
      title: 'Article 8 – Durée, suspension et résiliation',
      content: `L'abonnement est souscrit pour la durée choisie par l'utilisateur.

L'utilisateur peut résilier son abonnement à tout moment depuis son espace personnel.
La résiliation prend effet à la fin de la période de facturation en cours.

Coach DIA se réserve le droit de suspendre ou résilier un compte en cas de :
• non-respect des CGV,
• usage frauduleux,
• atteinte au bon fonctionnement de la plateforme.`
    },
    {
      title: 'Article 9 – Propriété intellectuelle',
      content: `L'ensemble des contenus présents sur la plateforme Coach DIA (textes, vidéos, audios, scénarios, algorithmes, interfaces, marques, logos) est protégé par le droit de la propriété intellectuelle.

Toute reproduction, diffusion ou exploitation non autorisée est strictement interdite.`
    },
    {
      title: 'Article 10 – Données personnelles',
      content: `Coach DIA collecte et traite les données personnelles conformément à la réglementation en vigueur (RGPD).

Les données sont utilisées uniquement dans le cadre :
• de la gestion des comptes,
• du suivi pédagogique,
• de l'amélioration continue des services.

L'utilisateur dispose d'un droit d'accès, de rectification et de suppression de ses données.`
    },
    {
      title: 'Article 11 – Responsabilité',
      content: `Coach DIA s'engage à mettre en œuvre tous les moyens raisonnables pour assurer la disponibilité et la qualité des services.

Toutefois, Coach DIA ne saurait être tenue responsable :
• d'une interruption temporaire du service,
• d'une mauvaise utilisation de la plateforme par l'utilisateur,
• de résultats professionnels non atteints.

Les formations proposées constituent une obligation de moyens, et non de résultat.`
    },
    {
      title: 'Article 12 – Attestations et reconnaissance',
      content: `Les attestations délivrées par Coach DIA certifient la participation et/ou la validation d'objectifs pédagogiques selon les critères définis.

Elles ne constituent pas, en l'état, un diplôme d'État, sauf mention contraire explicite.`
    },
    {
      title: 'Article 13 – Force majeure',
      content: `La responsabilité de Coach DIA ne pourra être engagée en cas de force majeure telle que définie par la jurisprudence française.`
    },
    {
      title: 'Article 14 – Modification des CGV',
      content: `Coach DIA se réserve le droit de modifier les présentes CGV à tout moment.

Les CGV applicables sont celles en vigueur à la date de la souscription.`
    },
    {
      title: 'Article 15 – Droit applicable et litiges',
      content: `Les présentes CGV sont régies par le droit français.

En cas de litige, une solution amiable sera recherchée avant toute action judiciaire.
À défaut, les tribunaux français seront seuls compétents.`
    }
  ];

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #FEF9E7 0%, #F5F3FF 50%, #FDF2F8 100%)' }}>
      <Navbar />
      
      {/* Header */}
      <section className="pt-32 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Back Button */}
          <motion.button
            {...fadeInUp}
            onClick={() => navigate('/')}
            className="flex items-center gap-2 mb-8 text-[#3D2B73] hover:text-[#F59E0B] transition-colors font-medium"
          >
            <ArrowLeft className="w-5 h-5" />
            Retour à l&apos;accueil
          </motion.button>

          {/* Title */}
          <motion.div {...fadeInUp} className="text-center mb-12">
            <div className="flex items-center justify-center gap-4 mb-6">
              <div className="p-4 rounded-2xl" style={{ background: 'linear-gradient(135deg, #F59E0B, #FBBF24)' }}>
                <FileText className="w-8 h-8 text-white" />
              </div>
            </div>
            <h1 
              className="text-3xl md:text-4xl lg:text-5xl font-black mb-4"
              style={{ 
                fontFamily: "'Manrope', sans-serif",
                color: '#1C104A',
                letterSpacing: '-0.02em'
              }}
            >
              Conditions Générales de Vente
            </h1>
            <p className="text-lg" style={{ color: '#6B5B95' }}>
              Dernière mise à jour : 26/12/2025
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Navigation rapide */}
          <motion.div 
            {...fadeInUp}
            className="mb-12 p-6 rounded-2xl"
            style={{ background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(10px)' }}
          >
            <h2 className="text-lg font-bold mb-4" style={{ color: '#1C104A' }}>
              Sommaire
            </h2>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-2">
              {articles.map((article, index) => (
                <a
                  key={index}
                  href={`#article-${index + 1}`}
                  className="text-sm py-1 px-2 rounded hover:bg-[#F59E0B]/10 transition-colors"
                  style={{ color: '#3D2B73' }}
                >
                  {article.title}
                </a>
              ))}
            </div>
          </motion.div>

          {/* Articles */}
          <div className="space-y-8">
            {articles.map((article, index) => (
              <motion.article
                key={index}
                id={`article-${index + 1}`}
                {...fadeInUp}
                className="p-6 rounded-2xl"
                style={{ 
                  background: index % 2 === 0 ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 0.3)',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <h2 
                  className="text-xl font-bold mb-4 pb-3 border-b"
                  style={{ color: '#1C104A', borderColor: 'rgba(245, 158, 11, 0.3)' }}
                >
                  {article.title}
                </h2>
                <div 
                  className="text-base leading-relaxed whitespace-pre-line"
                  style={{ color: '#3D2B73' }}
                >
                  {article.content}
                </div>
              </motion.article>
            ))}
          </div>

          {/* Footer note */}
          <motion.div 
            {...fadeInUp}
            className="mt-12 p-6 rounded-2xl text-center"
            style={{ background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.1), rgba(139, 92, 246, 0.1))' }}
          >
            <p className="text-sm" style={{ color: '#6B5B95' }}>
              Pour toute question relative aux présentes CGV, vous pouvez nous contacter à{' '}
              <a href="mailto:contact@coachdia.com" className="font-semibold hover:underline" style={{ color: '#F59E0B' }}>
                contact@coachdia.com
              </a>
            </p>
          </motion.div>

          {/* Back to top */}
          <motion.div {...fadeInUp} className="text-center mt-8">
            <button
              onClick={() => {
                // Scroll cross-target robuste : couvre desktop (window/html) et mobile (body avec overflow-y:auto height:100vh)
                const opts = { top: 0, left: 0, behavior: 'smooth' };
                window.scrollTo(opts);
                document.documentElement.scrollTo?.(opts);
                document.body.scrollTo?.(opts);
              }}
              className="px-6 py-3 rounded-xl text-sm font-semibold transition-all hover:scale-105"
              data-testid="cgv-scroll-top-btn"
              style={{ 
                background: 'rgba(255, 255, 255, 0.7)',
                color: '#3D2B73',
                backdropFilter: 'blur(10px)'
              }}
            >
              ↑ Retour en haut
            </button>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CGVPage;
